(function () {
  const selector = '[data-skyy-shipping-progress]';
  const cartEndpoints = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  let refreshTimer;
  let lastTotal;

  const formatMoney = (cents) => {
    const amount = Math.max(0, Number(cents) || 0) / 100;
    return `$${amount.toFixed(2)}`;
  };

  const getBars = () => Array.from(document.querySelectorAll(selector));

  const render = (total) => {
    lastTotal = Number(total) || 0;

    getBars().forEach((bar) => {
      const threshold = Number(bar.dataset.threshold) || 3500;
      const current = Math.max(0, lastTotal);
      const remaining = Math.max(threshold - current, 0);
      const percent = Math.min((current / threshold) * 100, 100);
      const message = bar.querySelector('[data-skyy-shipping-progress-message]');
      const fill = bar.querySelector('[data-skyy-shipping-progress-fill]');

      bar.dataset.current = String(current);

      if (message) {
        message.textContent =
          current >= threshold
            ? 'You unlocked free U.S. shipping.'
            : `You’re ${formatMoney(remaining)} away from free U.S. shipping.`;
      }

      if (fill) fill.style.width = `${percent}%`;
    });
  };

  const refresh = () => {
    if (!getBars().length) return;

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => (response.ok ? response.json() : Promise.reject(response)))
      .then((cart) => render(cart.total_price || 0))
      .catch(() => {
        if (typeof lastTotal === 'number') render(lastTotal);
      });
  };

  const scheduleRefresh = (delay = 180) => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, delay);
  };

  const handleCartData = (event) => {
    const total = event && event.cartData && event.cartData.total_price;

    if (typeof total === 'number') {
      render(total);
      return;
    }

    scheduleRefresh();
  };

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartData);
  }

  ['cart:updated', 'cart:refresh', 'product:added'].forEach((eventName) => {
    document.addEventListener(eventName, scheduleRefresh);
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (form && form.matches('form[action*="/cart/add"]')) {
        scheduleRefresh(700);
      }
    },
    true
  );

  if (window.fetch && !window.__skyyShippingProgressFetchPatched) {
    const originalFetch = window.fetch;
    window.fetch = function () {
      const request = arguments[0];
      const url = typeof request === 'string' ? request : request && request.url;
      const shouldRefresh = url && cartEndpoints.some((endpoint) => url.includes(endpoint));

      return originalFetch.apply(this, arguments).then((response) => {
        if (shouldRefresh) scheduleRefresh(250);
        return response;
      });
    };
    window.__skyyShippingProgressFetchPatched = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
